import React, { useState } from 'react'
import Swal from 'sweetalert2'

export default function Form(props){

    const [date, setDate] = useState("")

    function onDateChange(e){
        setDate(e.target.value)
    }

    function onSubmit(e){
        e.preventDefault();
        console.log(date, "---date input")
        let skg = new Date()
        let inputTanggal = new Date(date)
        console.log(skg, inputTanggal, "...compare date")
        if(skg<inputTanggal){
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Input date shall be from now to past!'
              })
        } else {
            let apiUrl = `https://api.nasa.gov/planetary/apod?api_key=qfu92Q3t1xBcZPHWCphiBhTZrqnB3KhQfsKNnbME&date=${date}`
            fetch(apiUrl)
            .then(resp => resp.json())
            .then(data=>{
                console.log(data,".....data")
                let id , lastPic
                //console.log(props.pics,'.....props pic')
                if(props.pics.length>0){
                    lastPic = props.pics[props.pics.length-1]
                    //console.log(lastPic,"...lastpic")
                    id = lastPic.id+1
                } else {
                    id = 1
                }
                //console.log(id,"...id")
                let newData = {
                    id: id,
                    date: data.date,
                    title: data.title,
                    explanation: data.explanation,
                    url: data.url
                }
                props.onSubmit(newData)
            })
            .catch(err=>{
                console.log(err)
            })
        }
    }

    return(
    <>
        <hr/>
        <form onSubmit={onSubmit}>
            <h4>See Others Pictures from NASA</h4>
            <label>Select date</label>
            <input onChange={onDateChange} type="date" placeholder="Date (YYYY-MM-DD)" />
            <button type="submit">SUBMIT</button>
        </form>
    </>
    )
}
